<div class="height-fixed"></div>
<header class="header">
  <div class="linha-header header">
    <div class="logo-area">
      <picture>
        <a routerLink="/"
          ><img
            class="logo-azulzinha"
            [lazyLoad]="'/assets/img/azulzinha-logo-nobg.png'"
        /></a>
      </picture>
    </div>
    <div class="menu-area-mobile mobile-only">
      <div class="fiserv-logo">
        <div class="fiserv-logo-img">
          <picture>
            <img
              class="img-logo-margin-left"
              [lazyLoad]="'/assets/img/caixa_negativa.png'"
            />
          </picture>
        </div>
      </div>
      <div (click)="toggleMobileMenu()">
        <img
          [src]="
            'assets/img/icons/' +
            (openMobileMenu ? 'icon-close.svg' : 'icon-hamburguer.svg')
          "
          alt=""
        />
      </div>
    </div>
    <div class="menu-area desk-only">
      <div class="menu-item">
        <div class="list-menu-itens">
          <ng-container *ngFor="let menuItem of menu; let i = index">
            <div
              class="btn-outline-secondary"
              (mouseenter)="isMenuOpen[i] = true"
              (mouseleave)="isMenuOpen[i] = false"
            >
              <span class="has-menu">{{ menuItem.title }}</span>
              <div class="sub-menu" *ngIf="isMenuOpen[i]">
                <div
                  class="menu-list"
                  [ngClass]="{ 'menu-list-single': i === 1 || menuItem.categories.length === 1 }"
                >
                  <div
                    *ngFor="let category of menuItem.categories"
                    class="item-list"
                  >
                    <span
                      [ngClass]="{ orange: category.orange }"
                      class="title-item-list"
                      >{{ category.name }}</span
                    >
                    <ng-container *ngFor="let item of category.items">
                      <a
                        *ngIf="category.linkExternal"
                        [href]="item.link"
                        target="_blank"
                        rel="noopener noreferrer"
                        (click)="handleCloseDialog(i); onNavigation(item.label)"
                      >
                        <span [ngClass]="{ highlighted: item.highlight }">
                          {{ item.label }}
                          <svg
                            *ngIf="item.highlight"
                            width="9"
                            height="8"
                            viewBox="0 0 9 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.58471 3.51506C7.2349 3.18215 6.87546 2.8597 6.53771 2.51381C5.98026 1.94347 5.43728 1.35847 4.88787 0.780176C4.75975 0.645756 4.70795 0.490385 4.76297 0.305296C4.81357 0.135701 4.93004 0.0406606 5.0927 0.00799784C5.2421 -0.0217336 5.36659 0.0331132 5.47221 0.144502C6.40476 1.13025 7.33771 2.11515 8.27106 3.10047C8.46344 3.30357 8.65824 3.50374 8.85021 3.70726C9.05463 3.92417 9.04739 4.19719 8.84337 4.40448C8.18391 5.07448 7.52688 5.747 6.86943 6.41952C6.40757 6.89229 5.94732 7.36675 5.48466 7.83868C5.28265 8.04471 5.0441 8.05266 4.86418 7.86673C4.69068 7.68751 4.6987 7.42327 4.88906 7.21683C5.73527 6.29892 6.58269 5.38227 7.4305 4.46604C7.43451 4.46772 7.3586 4.49577 7.29193 4.49577C5.03566 4.4941 2.77979 4.49451 0.523519 4.49409C0.437573 4.49409 0.351613 4.50122 0.267274 4.4652C0.0761048 4.38355 -0.0242904 4.20264 0.00502753 3.97945C0.0299277 3.78849 0.174903 3.64361 0.368481 3.62226C0.441174 3.6143 0.51507 3.61639 0.588566 3.61639C2.82476 3.61639 5.06056 3.61639 7.29676 3.61639H7.51082C7.53532 3.58289 7.55982 3.54939 7.58432 3.51589L7.58471 3.51506Z"
                              fill="#005FAF"
                            />
                          </svg>
                        </span>
                      </a>

                      <a
                        *ngIf="!category.linkExternal"
                        [routerLink]="item.link"
                        (click)="handleCloseDialog(i); onNavigation(item.label)"
                      >
                        <span [ngClass]="{ highlighted: item.highlight }">
                          {{ item.label }}
                          <svg
                            *ngIf="item.highlight"
                            width="9"
                            height="8"
                            viewBox="0 0 9 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.58471 3.51506C7.2349 3.18215 6.87546 2.8597 6.53771 2.51381C5.98026 1.94347 5.43728 1.35847 4.88787 0.780176C4.75975 0.645756 4.70795 0.490385 4.76297 0.305296C4.81357 0.135701 4.93004 0.0406606 5.0927 0.00799784C5.2421 -0.0217336 5.36659 0.0331132 5.47221 0.144502C6.40476 1.13025 7.33771 2.11515 8.27106 3.10047C8.46344 3.30357 8.65824 3.50374 8.85021 3.70726C9.05463 3.92417 9.04739 4.19719 8.84337 4.40448C8.18391 5.07448 7.52688 5.747 6.86943 6.41952C6.40757 6.89229 5.94732 7.36675 5.48466 7.83868C5.28265 8.04471 5.0441 8.05266 4.86418 7.86673C4.69068 7.68751 4.6987 7.42327 4.88906 7.21683C5.73527 6.29892 6.58269 5.38227 7.4305 4.46604C7.43451 4.46772 7.3586 4.49577 7.29193 4.49577C5.03566 4.4941 2.77979 4.49451 0.523519 4.49409C0.437573 4.49409 0.351613 4.50122 0.267274 4.4652C0.0761048 4.38355 -0.0242904 4.20264 0.00502753 3.97945C0.0299277 3.78849 0.174903 3.64361 0.368481 3.62226C0.441174 3.6143 0.51507 3.61639 0.588566 3.61639C2.82476 3.61639 5.06056 3.61639 7.29676 3.61639H7.51082C7.53532 3.58289 7.55982 3.54939 7.58432 3.51589L7.58471 3.51506Z"
                              fill="#005FAF"
                            />
                          </svg>
                        </span>
                      </a>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="i < menu.length - 1" class="line-divisor"></div>
          </ng-container>
          <div class="line-divisor"></div>
          <div class="btn-outline-secondary">
            <span class="has-menu"><a (click)="onNavigation('Blog')" routerLink="/blog">Blog</a></span>
          </div>
          <div class="line-divisor"></div>
          <div class="btn-outline-secondary">
            <span class="has-menu"><a (click)="onNavigation('Ajuda')" routerLink="/ajuda">Ajuda</a></span>
          </div>
        </div>
      </div>
    </div>
    <div class="desk-only">
      <div class="fiserv-logo">
        <div class="fiserv-logo-img">
          <picture>
            <img
              class="img-logo-margin-left"
              [lazyLoad]="'/assets/img/caixa_negativa.png'"
            />
          </picture>
        </div>
      </div>
      <div class="container-button">
        <a
          target="_blank"
          (click)="onNavigation('Acesse o Portal')"
          class="d-flex gap-2 align-items-center btn btn-primary bg-white btn-portal"
          href="https://portal.azulzinhadacaixa.com.br/"
        >
          <svg
            width="13"
            height="18"
            viewBox="0 0 13 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.4 8.8C6.18783 8.8 5.98434 8.88429 5.83431 9.03432C5.68429 9.18434 5.6 9.38783 5.6 9.6V12C5.6 12.2122 5.68429 12.4157 5.83431 12.5657C5.98434 12.7157 6.18783 12.8 6.4 12.8C6.61217 12.8 6.81566 12.7157 6.96569 12.5657C7.11571 12.4157 7.2 12.2122 7.2 12V9.6C7.2 9.38783 7.11571 9.18434 6.96569 9.03432C6.81566 8.88429 6.61217 8.8 6.4 8.8ZM10.4 5.6V4C10.4 2.93913 9.97857 1.92172 9.22843 1.17157C8.47828 0.421427 7.46087 0 6.4 0C5.33913 0 4.32172 0.421427 3.57157 1.17157C2.82143 1.92172 2.4 2.93913 2.4 4V5.6C1.76348 5.6 1.15303 5.85286 0.702944 6.30294C0.252856 6.75303 0 7.36348 0 8V13.6C0 14.2365 0.252856 14.847 0.702944 15.2971C1.15303 15.7471 1.76348 16 2.4 16H10.4C11.0365 16 11.647 15.7471 12.0971 15.2971C12.5471 14.847 12.8 14.2365 12.8 13.6V8C12.8 7.36348 12.5471 6.75303 12.0971 6.30294C11.647 5.85286 11.0365 5.6 10.4 5.6ZM4 4C4 3.36348 4.25286 2.75303 4.70294 2.30294C5.15303 1.85286 5.76348 1.6 6.4 1.6C7.03652 1.6 7.64697 1.85286 8.09706 2.30294C8.54714 2.75303 8.8 3.36348 8.8 4V5.6H4V4ZM11.2 13.6C11.2 13.8122 11.1157 14.0157 10.9657 14.1657C10.8157 14.3157 10.6122 14.4 10.4 14.4H2.4C2.18783 14.4 1.98434 14.3157 1.83431 14.1657C1.68429 14.0157 1.6 13.8122 1.6 13.6V8C1.6 7.78783 1.68429 7.58434 1.83431 7.43431C1.98434 7.28429 2.18783 7.2 2.4 7.2H10.4C10.6122 7.2 10.8157 7.28429 10.9657 7.43431C11.1157 7.58434 11.2 7.78783 11.2 8V13.6Z"
              fill="#005FAF"
            />
          </svg>
          Acesse o Portal</a
        >
        <a
          (click)="onNavigation('Peça já a azulzinha')"
          class="btn btn-primary btn-big"
          routerLink="/peca-azulzinha"
          >Peça já a azulzinha</a
        >
      </div>
    </div>
  </div>
</header>
<div *ngIf="openMobileMenu" class="menu-mobile-aberto overflow-auto">
  <div class="menu-mobile-content">
    <div class="container-button">
      <a
        target="_blank"
        (click)="onNavigation('Acesse o Portal'); toggleMobileMenu(); "
        class="d-flex gap-2 align-items-center justify-content-center btn btn-primary bg-white btn-portal"
        href="https://portal.azulzinhadacaixa.com.br/"
      >
        <svg
          width="13"
          height="18"
          viewBox="0 0 13 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.4 8.8C6.18783 8.8 5.98434 8.88429 5.83431 9.03432C5.68429 9.18434 5.6 9.38783 5.6 9.6V12C5.6 12.2122 5.68429 12.4157 5.83431 12.5657C5.98434 12.7157 6.18783 12.8 6.4 12.8C6.61217 12.8 6.81566 12.7157 6.96569 12.5657C7.11571 12.4157 7.2 12.2122 7.2 12V9.6C7.2 9.38783 7.11571 9.18434 6.96569 9.03432C6.81566 8.88429 6.61217 8.8 6.4 8.8ZM10.4 5.6V4C10.4 2.93913 9.97857 1.92172 9.22843 1.17157C8.47828 0.421427 7.46087 0 6.4 0C5.33913 0 4.32172 0.421427 3.57157 1.17157C2.82143 1.92172 2.4 2.93913 2.4 4V5.6C1.76348 5.6 1.15303 5.85286 0.702944 6.30294C0.252856 6.75303 0 7.36348 0 8V13.6C0 14.2365 0.252856 14.847 0.702944 15.2971C1.15303 15.7471 1.76348 16 2.4 16H10.4C11.0365 16 11.647 15.7471 12.0971 15.2971C12.5471 14.847 12.8 14.2365 12.8 13.6V8C12.8 7.36348 12.5471 6.75303 12.0971 6.30294C11.647 5.85286 11.0365 5.6 10.4 5.6ZM4 4C4 3.36348 4.25286 2.75303 4.70294 2.30294C5.15303 1.85286 5.76348 1.6 6.4 1.6C7.03652 1.6 7.64697 1.85286 8.09706 2.30294C8.54714 2.75303 8.8 3.36348 8.8 4V5.6H4V4ZM11.2 13.6C11.2 13.8122 11.1157 14.0157 10.9657 14.1657C10.8157 14.3157 10.6122 14.4 10.4 14.4H2.4C2.18783 14.4 1.98434 14.3157 1.83431 14.1657C1.68429 14.0157 1.6 13.8122 1.6 13.6V8C1.6 7.78783 1.68429 7.58434 1.83431 7.43431C1.98434 7.28429 2.18783 7.2 2.4 7.2H10.4C10.6122 7.2 10.8157 7.28429 10.9657 7.43431C11.1157 7.58434 11.2 7.78783 11.2 8V13.6Z"
            fill="#005FAF"
          />
        </svg>
        Acesse o Portal</a
      >
      <a
        (click)="onNavigation('Peça já a azulzinha');toggleMobileMenu();"
        class="btn btn-primary btn-big "
        routerLink="/peca-azulzinha"
        >Peça já a azulzinha</a
      >
    </div>
    <div class="menu-items">
      <div class="menu-mobile-item has-sub-mobile">
        <div>
          <div *ngFor="let menuItem of menu">
            <div
              [ngClass]="{ show: menuItem.showCategories }"
              class="header-menu-mobile"
              (click)="toggleCategories(menuItem)"
            >
              {{ menuItem.title }}
              <svg
                [ngClass]="{ 'rotate-up': menuItem.showCategories }"
                data-testid="geist-icon"
                height="16"
                stroke-linejoin="round"
                viewBox="0 0 16 16"
                width="16"
                style="color: currentcolor; transition: transform 0.3s ease"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M14.0607 5.49999L13.5303 6.03032L8.7071 10.8535C8.31658 11.2441 7.68341 11.2441 7.29289 10.8535L2.46966 6.03032L1.93933 5.49999L2.99999 4.43933L3.53032 4.96966L7.99999 9.43933L12.4697 4.96966L13 4.43933L14.0607 5.49999Z"
                  fill="currentColor"
                ></path>
              </svg>
            </div>

            <div
              [ngClass]="menuItem.showCategories ? 'show' : 'hidden'"
              class="sub-menu-list-mobile"
            >
              <div *ngFor="let category of menuItem.categories">
                <div
                  class="sub-menu-item"
                  (click)="toggleItems(menuItem, category)"
                >
                  <span
                    class="justify-content-between d-flex align-items-center"
                  >
                    {{ category.name }}
                    <svg
                      [ngClass]="{ 'rotate-up': category.showItems }"
                      data-testid="geist-icon"
                      height="16"
                      stroke-linejoin="round"
                      viewBox="0 0 16 16"
                      width="16"
                      style="
                        color: currentcolor;
                        transition: transform 0.3s ease;
                      "
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.0607 5.49999L13.5303 6.03032L8.7071 10.8535C8.31658 11.2441 7.68341 11.2441 7.29289 10.8535L2.46966 6.03032L1.93933 5.49999L2.99999 4.43933L3.53032 4.96966L7.99999 9.43933L12.4697 4.96966L13 4.43933L14.0607 5.49999Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </div>

                <div
                class="list-items"
                [ngClass]="category.showItems ? 'show' : 'hidden'"
              >
                <div
                  class="sub-sub-menu-item"
                  *ngFor="let item of category.items"
                >
                  <a
                    *ngIf="category.linkExternal; else internalLink"
                    [href]="item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    (click)="toggleMobileMenu(); onNavigation(item.label)"
                  >
                    <span [ngClass]="{ highlighted: item.highlight }">
                      {{ item.label }}
                      <svg
                        *ngIf="item.highlight"
                        width="9"
                        height="8"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.58471 3.51506C7.2349 3.18215 6.87546 2.8597 6.53771 2.51381C5.98026 1.94347 5.43728 1.35847 4.88787 0.780176C4.75975 0.645756 4.70795 0.490385 4.76297 0.305296C4.81357 0.135701 4.93004 0.0406606 5.0927 0.00799784C5.2421 -0.0217336 5.36659 0.0331132 5.47221 0.144502C6.40476 1.13025 7.33771 2.11515 8.27106 3.10047C8.46344 3.30357 8.65824 3.50374 8.85021 3.70726C9.05463 3.92417 9.04739 4.19719 8.84337 4.40448C8.18391 5.07448 7.52688 5.747 6.86943 6.41952C6.40757 6.89229 5.94732 7.36675 5.48466 7.83868C5.28265 8.04471 5.0441 8.05266 4.86418 7.86673C4.69068 7.68751 4.6987 7.42327 4.88906 7.21683C5.73527 6.29892 6.58269 5.38227 7.4305 4.46604C7.43451 4.46772 7.3586 4.49577 7.29193 4.49577C5.03566 4.4941 2.77979 4.49451 0.523519 4.49409C0.437573 4.49409 0.351613 4.50122 0.267274 4.4652C0.0761048 4.38355 -0.0242904 4.20264 0.00502753 3.97945C0.0299277 3.78849 0.174903 3.64361 0.368481 3.62226C0.441174 3.6143 0.51507 3.61639 0.588566 3.61639C2.82476 3.61639 5.06056 3.61639 7.29676 3.61639H7.51082C7.53532 3.58289 7.55982 3.54939 7.58432 3.51589L7.58471 3.51506Z"
                          fill="#005FAF"
                        />
                      </svg>
                    </span>
                  </a>
              
                  <ng-template #internalLink>
                    <a
                      [routerLink]="item.link"
                      (click)="toggleMobileMenu(); onNavigation(item.label)"
                    >
                      <span [ngClass]="{ highlighted: item.highlight }">
                        {{ item.label }}
                        <svg
                        *ngIf="item.highlight"
                        width="12"
                        height="12"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.58471 3.51506C7.2349 3.18215 6.87546 2.8597 6.53771 2.51381C5.98026 1.94347 5.43728 1.35847 4.88787 0.780176C4.75975 0.645756 4.70795 0.490385 4.76297 0.305296C4.81357 0.135701 4.93004 0.0406606 5.0927 0.00799784C5.2421 -0.0217336 5.36659 0.0331132 5.47221 0.144502C6.40476 1.13025 7.33771 2.11515 8.27106 3.10047C8.46344 3.30357 8.65824 3.50374 8.85021 3.70726C9.05463 3.92417 9.04739 4.19719 8.84337 4.40448C8.18391 5.07448 7.52688 5.747 6.86943 6.41952C6.40757 6.89229 5.94732 7.36675 5.48466 7.83868C5.28265 8.04471 5.0441 8.05266 4.86418 7.86673C4.69068 7.68751 4.6987 7.42327 4.88906 7.21683C5.73527 6.29892 6.58269 5.38227 7.4305 4.46604C7.43451 4.46772 7.3586 4.49577 7.29193 4.49577C5.03566 4.4941 2.77979 4.49451 0.523519 4.49409C0.437573 4.49409 0.351613 4.50122 0.267274 4.4652C0.0761048 4.38355 -0.0242904 4.20264 0.00502753 3.97945C0.0299277 3.78849 0.174903 3.64361 0.368481 3.62226C0.441174 3.6143 0.51507 3.61639 0.588566 3.61639C2.82476 3.61639 5.06056 3.61639 7.29676 3.61639H7.51082C7.53532 3.58289 7.55982 3.54939 7.58432 3.51589L7.58471 3.51506Z"
                          fill="#EE8236"
                        />
                      </svg>
                      </span>
                    </a>
                  </ng-template>
                </div>
              </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="menu-mobile-item has-sub-mobile">
        <div class="header-menu-mobile">
          <a (click)="toggleMobileMenu(); onNavigation('Blog')" routerLink="/blog"
            >Blog</a
          >
        </div>
      </div>
      <div class="menu-mobile-item">
        <div class="header-menu-mobile">
          <a (click)="toggleMobileMenu(); onNavigation('Ajuda')" routerLink="/ajuda"
            >Ajuda</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
